import React from "react";
import MessageAttachments from "components/MessageAttachments";
import useViewController from "./viewController";
import DefaultMessageView from "../DefaultMessageView";
import { PropsMessageItem } from "../types";
import "./style.scss";

export default function MessageDefault({
  message,
  className,
  rendered,
  avatarSize,
  showScreenName,
  startMessage,
  endMessage,
  isLiveChat,
  authUser,
  screenName,
  guestUser,
}: PropsMessageItem) {
  const { highlightMessage, selfMessage, desktopUp, attachmentViews } = useViewController(
    message,
    authUser,
    isLiveChat,
    guestUser
  );

  const cls = ["default-message"];
  if (className) cls.push(className);
  const clsContent = ["default-message__content"];
  if (highlightMessage) clsContent.push("__highlight-message");
  if (isLiveChat && !desktopUp) clsContent.push("__mobile-live-message");

  return (
    <DefaultMessageView
      message={message}
      className={cls.join(" ")}
      rendered={rendered}
      avatarSize={avatarSize}
      showScreenName={showScreenName}
      startMessage={startMessage}
      endMessage={endMessage}
      isLiveChat={isLiveChat}
      selfMessage={selfMessage}
      highlightMessage={highlightMessage}
      screenName={screenName}
      contentMessage={
        <div className={clsContent.join(" ")}>
          <pre className="default-message__text">{message.text}</pre>
          {attachmentViews.length > 0 && <MessageAttachments attachments={attachmentViews} />}
        </div>
      }
    />
  );
}
